import ValueTracker from "../../../../prop-trackers/value-tracker.js";
import PropTracker from "../../../../prop-trackers/prop-tracker.js";
import { CombinerForEach, ValueCombiner } from "../../../../prop-tracker-utils/combiner-for-each.js";
import SinglePropChainTracker from "../../../../prop-tracker-utils/single-prop-chain-tracker.js";

class ContentTrackerController {
    constructor(evtCtx, contentController) {
        this._contentTracker = new PropTracker();
        this._labelTracker = new PropTracker();

        this._combiner = new CombinerForEach((key) => new LabelTracker(evtCtx, contentController));
        this._combiner.setSource("content", this._contentTracker);
        this._combiner.setSource("label", this._labelTracker);
    }

    trackContent(contentData, contentDataEvents) {
        this._contentTracker.track(contentData, contentDataEvents);
    }

    trackLabels(labels, labelEvents) {
        this._labelTracker.track(labels, labelEvents);
    }

    update() {
        this._combiner.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update();
            }
        });
    }
}

class LabelTracker extends ValueCombiner {
    constructor(evtCtx, contentController) {
        super();

        this._evtCtx = evtCtx;
        this._contentController = contentController;

        this._contentTracker = new SinglePropChainTracker(evtCtx);
        this._labelTracker = new ValueTracker();

        const needsUpdate = () => this.protected_needsUpdate();
        this._contentTracker.listenNeedsUpdate(needsUpdate);
        this._labelTracker.listenNeedsUpdate(needsUpdate);
    }

    setValue(key, value) {
        if (value) {
            switch (key) {
                case "content":
                    this._contentTracker.track(value, ["label", "content"]);
                    break;

                case "label":
                    this._labelTracker.setValue(value);
                    break;

                default:
                    throw new Error(("Invalid key: "+String(key)));
            }
        } else {
            this.deleteValue(key);
        }
    }

    deleteValue(key) {
        switch (key) {
            case "content":
                this._contentTracker.track();
                break;

            case "label":
                this._labelTracker.deleteValue();
                break;

            default:
                throw new Error(("Invalid key: "+String(key)));
        }
    }

    protected_startUpdate() {
        this._labelTracker.update(({ prop: { newValue: label } }) => {
            this._contentTracker.update(({ prop: { newValue: content } }) => {
                if (label) {
                    this._contentController.setContent(label, content);
                }
            });
        });
    }

    protected_finishUpdate() {}
}

export default ContentTrackerController;
